import { render } from "./StructureEditor.vue?vue&type=template&id=14fd6dfa&scoped=true"
import script from "./StructureEditor.vue?vue&type=script&lang=js"
export * from "./StructureEditor.vue?vue&type=script&lang=js"

import "./StructureEditor.vue?vue&type=style&index=0&id=14fd6dfa&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14fd6dfa"]])

export default __exports__